module.exports = __webpack_public_path__ + "static/media/32.680a1e45.jpg";